import { addAuthInterceptors } from '@dentalux/security';
import axios from 'axios';
const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_ANA_URL
});
addAuthInterceptors(http);
export const getAnamnesis = async ({
  personReferenceId,
  clinicReferenceId,
  size
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/anamnesis`, {
    params: {
      clinicReferenceId,
      size
    }
  });
  return data;
};
export const getAnamnesisListing = async ({
  personReferenceId,
  includeDeprecated,
  onlyDeprecated
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/clinics/anamnesis`, {
    params: {
      includeDeprecated,
      onlyDeprecated
    }
  });
  return data;
};
export const getClinicDocuments = async ({
  personReferenceId,
  includeDeprecated,
  onlyDeprecated
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/clinics/documents`, {
    params: {
      includeDeprecated,
      onlyDeprecated
    }
  });
  return data;
};
const signedDocumentBasePath = ({
  personReferenceId,
  clinicReferenceId,
  step
}) => `/external/persons/${personReferenceId}/clinics/${clinicReferenceId}/signed-documents/${step}`;
export const getSignedDocument = async ({
  personReferenceId,
  clinicReferenceId,
  step,
  language
}) => {
  const path = signedDocumentBasePath({
    personReferenceId,
    clinicReferenceId,
    step
  });
  const upperLanguage = language.toUpperCase();
  const {
    data
  } = await http.get(path, {
    params: {
      language: upperLanguage
    }
  });
  return {
    ...data,
    filePath: `${process.env.NEXT_PUBLIC_ANA_URL}${path}/download?language=${upperLanguage}`
  };
};
export const postSignedDocumentSign = async ({
  personReferenceId,
  clinicReferenceId,
  step,
  signatureEncoded,
  language
}) => {
  const path = signedDocumentBasePath({
    personReferenceId,
    clinicReferenceId,
    step
  });
  const upperLanguage = language.toUpperCase();
  const {
    data
  } = await http.post(`${path}/sign`, {
    signatureEncoded,
    language: upperLanguage
  });
  return {
    ...data,
    filePath: `${process.env.NEXT_PUBLIC_ANA_URL}${path}/download?language=${upperLanguage}`
  };
};
export const getDocumentHistory = async ({
  personReferenceId,
  clinicReferenceId,
  step
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/clinics/${clinicReferenceId}/documents/${step}/history`);
  return data;
};

// Absolute URL of a specific historic signed-document version's PDF, for the viewer.
export const signedDocumentVersionFilePath = ({
  personReferenceId,
  clinicReferenceId,
  step,
  documentReferenceId
}) => `${process.env.NEXT_PUBLIC_ANA_URL}${signedDocumentBasePath({
  personReferenceId,
  clinicReferenceId,
  step
})}/${documentReferenceId}/download`;
export const postFactoringAgreement = async ({
  personReferenceId,
  language,
  clinicReferenceId
}) => {
  const {
    data
  } = await http.post(`/external/persons/${personReferenceId}/factoring-agreements`, {
    clinicReferenceId,
    language: language.toUpperCase()
  });

  // we determine the file path like this to be able to use it as static parameter for Next.js Document filePath downstream
  data.filePath = `${process.env.NEXT_PUBLIC_ANA_URL}/external/persons/${personReferenceId}/factoring-agreements/${data.factoringAgreementReferenceId}/contents`;
  return data;
};
export const postFactoringAgreementSign = async ({
  personReferenceId,
  language,
  clinicReferenceId,
  factoringAgreementReferenceId,
  signatureEncoded
}) => {
  const {
    data
  } = await http.post(`/external/persons/${personReferenceId}/factoring-agreements/${factoringAgreementReferenceId}/signatures`, {
    clinicReferenceId,
    signatureEncoded,
    language: language.toUpperCase()
  });
  return data;
};
export const getAnamnesisById = async ({
  personReferenceId,
  anamnesisReferenceId
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/anamnesis/${anamnesisReferenceId}`);
  return data;
};
export const getAnamnesisFromHistory = async ({
  personReferenceId,
  anamnesisHistoryReferenceId
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/anamnesis-histories/${anamnesisHistoryReferenceId}`, {
    headers: {
      Accept: 'application/json'
    }
  });
  return data;
};
export const postAnamnesis = async ({
  personReferenceId,
  formData,
  signatureEncoded,
  clinicReferenceId
}) => {
  const {
    data
  } = await http.post(`/external/persons/${personReferenceId}/anamnesis/v2`, {
    ...formData,
    signatureEncoded,
    clinicReferenceId
  });
  return data;
};
export const getOptins = async ({
  personReferenceId
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/opts`);
  return data;
};
export const postOptins = async ({
  personReferenceId,
  clinicReferenceId,
  ...body
}) => {
  const {
    data
  } = await http.post(`/external/persons/${personReferenceId}/clinics/${clinicReferenceId}/opts`, body);
  return data;
};